module.exports = __webpack_public_path__ + "img/45.3ec2166f.jpeg";